module.exports = __webpack_public_path__ + "static/media/om_nose_bulbous.7d2e975c.png";